import { useProjectStore } from 'store/useProjectStore'
import { IconSparkles } from '@tabler/icons-react'
import { PageHeader } from './PageHeader'
import { useProject } from 'hooks/projects'
import { ModalV2 } from './Common/ModalV2'
import { UploadFile } from './UploadFile'
import { UploadYouTube } from './UploadYouTube'
import { UploadRSS } from './UploadRSS'

export const UploadModal = () => {
  const { showUploadModal, setShowUploadModal } = useProjectStore()

  return (
    <ModalV2
      open={showUploadModal}
      onClose={() => setShowUploadModal(false)}
      includePadding={false}
      includeCloseButton={true}
      className="md:max-w-xl"
    >
      <UploadForm />
    </ModalV2>
  )
}

export const UploadForm = () => {
  return (
    <div className="flex flex-col gap-4 p-4">
      <PageHeader icon={IconSparkles} title={`Import your media`} />
      <div className="flex flex-col gap-4">
        <UploadFile onUpload={() => {}} />
        <OrLine />
        <UploadYouTube onUpload={() => {}} />
        <OrLine />
        <UploadRSS onUpload={() => {}} />
      </div>
    </div>
  )
}

export const OrLine = () => {
  return (
    <div className="flex items-center justify-center gap-2">
      <div className="h-px w-full bg-gray-200"></div>
      <p className="text-sm text-gray-500">OR</p>
      <div className="h-px w-full bg-gray-200"></div>
    </div>
  )
}
